import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { ListenHelpCard } from '../../components/student/ListenHelpCard';
const packages = [{
  name: '3-Class Renewal Package (select your own courses-9 hours)',
  credits: 9,
  price: '$49.95'
}, {
  name: '3-Class Broker Management Clinic (Preset with BMC 1-2-3 for 9 hours)',
  credits: 9,
  price: '$54.95',
  hasDetails: true
}, {
  name: '3-Class Property Management BMC (Preset with BMC 1-2-3B for 9 hours)',
  credits: 9,
  price: '$54.95',
  hasDetails: true
}, {
  name: '6-Class Salesperson Renewal Package (select your own courses-18 hours)',
  credits: 18,
  price: '$69.95'
}, {
  name: '6-Class FIRST TIME Renewal Package (Preset -18 Hours)',
  credits: 18,
  price: '$69.95'
}, {
  name: '#1 8-Class Salesperson Renewal Package (Preset-24 hours)',
  credits: 24,
  price: '$89.95',
  hasDetails: true
}, {
  name: '#2 8-Class Salesperson Renewal Package (Preset-24 hours with NAR Ethics)',
  credits: 24,
  price: '$89.95',
  hasDetails: true
}, {
  name: '10-class Broker Renewal Package (Preset-30 hours with NAR Ethics)',
  credits: 30,
  price: '$104.95',
  hasDetails: true
}, {
  name: '10-Class Renewal Package for Property Management Brokers (Preset 30-hours with NAR Ethics and BMC #3B)',
  credits: 30,
  price: '$104.95',
  hasDetails: true
}];
const singleClasses = [{
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: 'Comm. Standards',
  credits: 3,
  description: "CS CE credit + Complies with current NAR cycle January 2025-December 2027 The Commissioner's",
  price: '$19.95'
}, {
  name: 'NAR Code of Ethics (NO CE CREDIT)',
  creditType: 'NONE',
  credits: 0,
  description: '(No CE Credit - No Clock Hours) Complies with current cycle January 2025-December 2027 REMEMBER-SEND',
  price: '$14.95'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  creditType: 'General',
  credits: 3,
  description: 'Required to be Prepared (GEN)-NEW ADRE Class Requirement as of 2025 Our obligation',
  price: '$19.95'
}, {
  name: 'Are They Represented?',
  creditType: 'Agency Law',
  credits: 3,
  description: 'Are They Represented? (AL) This class will explore the history of agency disclosure, from sub agency',
  price: '$19.95'
}, {
  name: 'Mastering Agency Agreements',
  creditType: 'Agency Law',
  credits: 3,
  description: 'Mastering Agency Agreements (AL) Objective: Class will review the way real estate agency',
  price: '$19.95'
}, {
  name: 'A Letter From ADRE',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'A Letter From ADRE (CS) This course will review both the Arizona Revised Statutes and',
  price: '$19.95'
}, {
  name: "Don't Lose Your License",
  creditType: 'Comm. Standards',
  credits: 3,
  description: "Don't Lose Your License (CS) This class will look at various parts of the Arizona Revised Statutes",
  price: '$19.95'
}, {
  name: 'BMC #1 AZ Residential-Statutes and Rules',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'BMC#1 AZ Residential Statutes & Rules (CS) This is part 1 of the 3 required, 9 hour Broker Management',
  price: '$19.95'
}, {
  name: 'BMC #2 AZ Residential-Broker Policies',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'BMC#2 AZ Residential Broker Policies (CS) This is part 2 of the 3 required, 9 hour Broker Management Clinic required',
  price: '$19.95'
}, {
  name: 'BMC #3 AZ Residential-Broker Supervision',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'BMC#3 AZ Residential Broker Supervision (CS) This is part 3 of the 3 required, 9 hour Broker Management',
  price: '$19.95'
}, {
  name: 'BMC #3B Property Management',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'Broker Management Clinic #3B Property Management (CS) If the broker conducts or allows PROPERTY',
  price: '$19.95'
}, {
  name: 'What Goes Wrong In Contracts',
  creditType: 'Contract Law',
  credits: 3,
  description: 'What Goes Wrong In Contracts? (CL) A review of the common contract issues in residential',
  price: '$19.95'
}, {
  name: 'Avoid The Oops: Contract Smarts for Agents',
  creditType: 'Contract Law',
  credits: 3,
  description: 'Avoid The Oops: Contract Smarts For Agents (CL) A review of a valid, enforceable',
  price: '$19.95'
}];
export function StudentDashboard() {
  const navigate = useNavigate();
  return <div className="space-y-8" data-id="element-2341">
      {/* Page Title */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2342">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2343">
          On-Demand Classes
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2344">
          Browse packages and individual courses for your continuing education.
        </p>
      </div>

      {/* Requirement Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2345">
        <Card className="border-slate-200" data-id="element-2346">
          <div className="p-5" data-id="element-2347">
            <h2 className="text-sm font-bold text-slate-800 mb-1" data-id="element-2348">
              Salesperson / Associate Broker Requirements
            </h2>
            <p className="text-sm font-semibold mb-2" style={{
            color: '#4A2D8F'
          }} data-id="element-2349">
              24 hours every 2-year renewal cycle
            </p>
            <p className="text-xs text-slate-600 leading-relaxed" data-id="element-2350">
              <span className="font-semibold text-slate-700" data-id="element-2351">Required CE:</span>{' '}
              Agency Law, Contract Law, Disclosure, Fair Housing, Real Estate
              Legal Issues, Requirements for Licensees (formerly Commissioner's
              Standards), Firewise / Deed Fraud / Arizona Water, plus Elective
              hours.
            </p>
          </div>
        </Card>
        <Card className="border-slate-200" data-id="element-2352">
          <div className="p-5" data-id="element-2353">
            <h2 className="text-sm font-bold text-slate-800 mb-1" data-id="element-2354">
              Broker Requirements
            </h2>
            <p className="text-sm font-semibold mb-2" style={{
            color: '#4A2D8F'
          }} data-id="element-2355">
              30 hours every 2-year renewal cycle
            </p>
            <p className="text-xs text-slate-600 leading-relaxed" data-id="element-2356">
              For Designated, Self-employed, and Delegated Associate Brokers.
              Includes Broker Management Clinic (BMC) courses plus
              required/elective CE categories.
            </p>
          </div>
        </Card>
      </div>

      {/* Listen instead of read help */}
      <ListenHelpCard data-id="element-2357" />

      {/* On-Demand Packages */}
      <div data-id="element-2358">
        <h2 className="text-lg font-semibold text-slate-800 mb-3" data-id="element-2359">
          On-Demand Packages
        </h2>
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2360">
          <div className="overflow-x-auto" data-id="element-2361">
            <table className="w-full text-sm text-left" data-id="element-2362">
              <thead style={{
              backgroundColor: '#4A2D8F'
            }} className="text-white font-medium" data-id="element-2363">
                <tr data-id="element-2364">
                  <th className="px-4 py-3 border-r border-purple-700" data-id="element-2365">
                    Package Name
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-24" data-id="element-2366">
                    Credit Hours
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-20" data-id="element-2367">
                    Price
                  </th>
                  <th className="px-3 py-3 text-center w-28" data-id="element-2368">Purchase</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-2369">
                {packages.map((pkg, i) => <tr key={i} className="hover:bg-purple-50/30" data-id="element-2370">
                    <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-2371">
                      <span className="text-slate-800" data-id="element-2372">{pkg.name}</span>
                      {pkg.hasDetails && <button className="ml-1 text-blue-600 hover:underline text-xs" data-id="element-2373">
                          Details
                        </button>}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-2374">
                      {pkg.credits}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center font-medium" style={{
                  color: '#CC0000'
                }} data-id="element-2375">
                      {pkg.price}
                    </td>
                    <td className="px-3 py-2.5 text-center" data-id="element-2376">
                      <button className="px-3 py-1 text-white text-xs font-bold rounded" style={{
                    backgroundColor: '#2E7D32'
                  }} data-id="element-2377">
                        BUY NOW
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* On-Demand Single Classes */}
      <div data-id="element-2378">
        <h2 className="text-lg font-semibold text-slate-800 mb-3" data-id="element-2379">
          On-Demand Single Classes
        </h2>
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2380">
          <div className="overflow-x-auto" data-id="element-2381">
            <table className="w-full text-sm text-left" data-id="element-2382">
              <thead style={{
              backgroundColor: '#4A2D8F'
            }} className="text-white font-medium" data-id="element-2383">
                <tr data-id="element-2384">
                  <th className="px-4 py-3 border-r border-purple-700 w-44" data-id="element-2385">
                    Class Name
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 w-28" data-id="element-2386">
                    Credit Type
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-16" data-id="element-2387">
                    Credit Hours
                  </th>
                  <th className="px-4 py-3 border-r border-purple-700" data-id="element-2388">
                    Description
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-20" data-id="element-2389">
                    Price
                  </th>
                  <th className="px-3 py-3 text-center w-28" data-id="element-2390">Purchase</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-2391">
                {singleClasses.map((cls, i) => <tr key={i} className="hover:bg-purple-50/30" data-id="element-2392">
                    <td className="px-4 py-2.5 border-r border-slate-200 font-medium text-slate-800" data-id="element-2393">
                      {cls.name}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-slate-600" data-id="element-2394">
                      {cls.creditType}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-2395">
                      {cls.credits}
                    </td>
                    <td className="px-4 py-2.5 border-r border-slate-200 text-slate-600 text-xs leading-relaxed" data-id="element-2396">
                      {cls.description}{' '}
                      <button className="text-blue-600 hover:underline" data-id="element-2397">
                        More &gt;
                      </button>
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center font-medium" style={{
                  color: '#CC0000'
                }} data-id="element-2398">
                      {cls.price}
                    </td>
                    <td className="px-3 py-2.5 text-center" data-id="element-2399">
                      <button className="px-3 py-1 text-white text-xs font-bold rounded" style={{
                    backgroundColor: '#2E7D32'
                  }} data-id="element-2400">
                        BUY NOW
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>;
}